require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-react-and-redux-connect-redux-to-react.json") })
        }
      }, "path---front-end-libraries-react-and-redux-connect-redux-to-react");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-react-and-redux-connect-redux-to-react!./.cache/json/front-end-libraries-react-and-redux-connect-redux-to-react.json
// module id = 2056
// module chunks = 231608221292675